import * as React from "react";
import clsx from "clsx";
import css from "../GoodNews.module.css";
import ReactQuill from "react-quill-new";
import 'react-quill-new/dist/quill.snow.css';
import {JSX, useEffect, useRef, useState} from "react";
import {GoodNewsActivityI} from "../model/GoodNewsActivityI.ts";
import {GoodNews} from "../api/GoodNews.ts";
import {GoodNewsManageI} from "../model/GoodNewsManageI.ts";
import {Decorator} from "../../../../Components/Tabulator/Decorator.tsx";


export interface GoodNewsFormProps {
    goodsNewsApi: GoodNews;
    originalGood: GoodNewsManageI;
    formConfirm: (good: GoodNewsActivityI) => void;
    formCancel: () => void;
}

export const GoodNewsForm: React.FC<GoodNewsFormProps> = (props): JSX.Element => {

    const dialogRef = useRef<HTMLDivElement>(null!);
    const dialogBodyRef = useRef<HTMLDivElement>(null!);
    const [isHoveringActive, setIsHoveringActive] = useState<boolean>(false);
    const [active, setActive] = useState<boolean>(props.originalGood.active);
    const [note, setNote] = useState<string>(props.originalGood.note);
    const [hasChanges, setHasChanges] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const handleSaveChanges = async () => {
        if (hasChanges) {
            const request: GoodNewsActivityI = {
                goodId: props.originalGood.goodId,
                active: active,
                note: note,
            }
            console.log('request: ', request);

            const element = dialogBodyRef.current;

            try {
                beginSave();
                console.log('trying to update good', element);

                const response = await props.goodsNewsApi.updateGoodPromotion(request);
                setHasChanges(false);

                saveSuccess();
                props.formConfirm(response);
            } catch (e) {
                const msg = e instanceof Error ? e.message : String(e);
                saveException(msg);
            }
        }
    }


    const handleCancelDialog = () => {
        props.formCancel();
    };


    const normalizeQuillValue = (value?: string | null): string => {
        const normalized = value?.trim() ?? "";

        if (
            normalized === "<p></p>" ||
            normalized === "<p><br></p>" ||
            normalized === "<div><br></div>"
        ) {
            return "";
        }

        return normalized;
    };


    const beginSave = () => {
        setIsSaving(true);
        Decorator.formUpdateStart(dialogBodyRef.current);

    }

    const saveSuccess = () => {
        setIsSaving(false);
        Decorator.formUpdateSuccess(dialogBodyRef.current);

    }

    const saveException = (msg: string) => {
        setIsSaving(false);
        Decorator.formUpdateException(dialogBodyRef.current, msg);

    }

    useEffect(() => {
        console.log('originalGood: ', props.originalGood);
        console.log('active: ', active);
        console.log('note: ', note);
        setHasChanges(active !== props.originalGood.active || note !== props.originalGood.note);
    }, [active, note]);


    return (
        <div ref={dialogRef}
             className={`form-wrapper ${isSaving ? 'is-loading' : ''} clsx(css.dialog)`}
             style={{
                 position: "fixed",
                 top: 0,
                 left: 0,
                 width: "100%",
                 height: "100%",
                 backgroundColor: "rgba(0, 0, 0, 0.5)",
                 zIndex: 20000,
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center"
             }}
             onClick={handleCancelDialog}
        >
            {isSaving && (
                    <div className="form-glass-overlay">
                        <div className="loading-progress-bar" />
                        <div className="loading-status-text">Zapisywanie zmian...</div>
                    </div>
                )
            }

            <div ref={dialogBodyRef}
                 style={{
                    backgroundColor: "white",
                    padding: "20px",
                    borderRadius: "8px",
                    minWidth: "500px",
                    maxWidth: "800px",
                    maxHeight: "80vh",
                    overflow: "auto"
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h1>Edycja wiersza</h1>
                <div className={clsx(css.cannotEdit)} style={{marginBottom: "15px"}}>
                    <strong>ID:</strong> {props.originalGood.goodId}
                </div>
                <div className={clsx(css.cannotEdit)} style={{marginBottom: "15px"}}>
                    <strong>EPID:</strong> {props.originalGood.epid}
                </div>
                <div style={{marginBottom: "15px", display: "flex", alignItems: "center"}}>
                    <strong style={{marginRight: "10px"}}>Aktywny:</strong>
                    <div
                        onClick={() => setActive(!active)}
                        onMouseEnter={() => setIsHoveringActive(true)}
                        onMouseLeave={() => setIsHoveringActive(false)}
                        style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: isHoveringActive ? "1px solid #ccc" : "none",
                            borderRadius: "3px",
                            backgroundColor: isHoveringActive ? "#f5f5f5" : "transparent"
                        }}
                    >

                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            style={{display: "block"}}
                        >
                            {active ? (
                                <path
                                    d="M7 10l4 4 7-10"
                                    stroke="#4CAF50"
                                    strokeWidth="5"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            ) : (
                                <>
                                    <line
                                        x1="5"
                                        y1="5"
                                        x2="15"
                                        y2="15"
                                        stroke="#F44336"
                                        strokeWidth="5"
                                        strokeLinecap="round"
                                    />
                                    <line
                                        x1="15"
                                        y1="5"
                                        x2="5"
                                        y2="15"
                                        stroke="#F44336"
                                        strokeWidth="5"
                                        strokeLinecap="round"
                                    />
                                </>
                            )}
                        </svg>

                    </div>
                </div>
                <div className={clsx(css.cannotEdit)} style={{marginBottom: "15px"}}>
                    <strong>Data wyświetlenia:</strong>
                    {props.originalGood.lastPromotionDate ? String(props.originalGood.lastPromotionDate) : ''}
                </div>
                <div className={clsx(css.cannotEdit)} style={{marginBottom: "15px"}}>
                    <strong>Streszczenie:</strong>
                    {props.originalGood.shortDescription}
                </div>
                <div className={clsx(css.cannotEdit)} style={{marginBottom: "15px"}}>
                    <strong>Artykuł:</strong>
                    {props.originalGood.description}
                </div>
                {props.originalGood.image && (
                    <div style={{marginBottom: "15px"}}>
                        <strong>Grafika:</strong>
                        <div>
                            <img
                                src={props.originalGood.image}
                                alt="Article"
                                style={{maxWidth: "100%", maxHeight: "300px"}}
                            />
                        </div>
                    </div>
                )}

                <div>
                    <div>
                        <strong style={{display: "block", marginBottom: "8px"}}>Notatka:</strong>
                        <div style={{backgroundColor: "white", height: "350px", marginBottom: "50px"}}>
                            <ReactQuill
                                theme="snow"
                                value={note}
                                onChange={(note: string) => {
                                    setNote(normalizeQuillValue(note));
                                }}
                                style={{height: "100%"}}
                                modules={{
                                    toolbar: [
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{'list': 'ordered'}, {'list': 'bullet'}]
                                    ],
                                }}
                            />
                        </div>
                    </div>

                    <div style={{display: "flex", gap: "10px"}}>
                        <button
                            onClick={handleSaveChanges}
                            disabled={!hasChanges}
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#4caf50",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: !hasChanges ? "not-allowed" : "pointer",
                                opacity: !hasChanges ? 0.5 : 1
                            }}
                        >
                            Zapisz
                        </button>
                        <button
                            onClick={handleCancelDialog}
                            disabled={isSaving}
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#f44336",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: isSaving ? "not-allowed" : "pointer",
                                opacity: isSaving ? 0.5 : 1
                            }}
                        >
                            Anuluj
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )
}